import React, { Component } from "react";
import {
  Button,
  Navbar,
  NavDropdown,
  Nav,
  Form,
  FormControl,
} from "react-bootstrap";
// import 'bootstrap/dist/css/bootstrap.min.css';
import "../css/nav.css";
class MyNav extends Component {
  render() {
    return (
      <Navbar className="nav" variant="dark" expand="lg">
        <div className="container">
          <Navbar.Brand
            style={{ fontSize: "1 rem !important" }}
            href="/"
            className="nav-text"
          >
            Status.fyi
          </Navbar.Brand>
          <Navbar.Toggle
            style={{ alignItems: "right !important" }}
            aria-controls="basic-navbar-nav"
          />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav style={{ textAlign: "right !important" }} className="ml-auto">
              <Nav.Link href="/">Home</Nav.Link>
              <Nav.Link href="/link">Link</Nav.Link>
              <NavDropdown title="Contribute" id="basic-nav-dropdown">
                <NavDropdown.Item href="/action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="/action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="/action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            {/* <Form inline>
            <FormControl type="text" placeholder="Search" className="mr-sm-2" />
            <Button variant="outline-success">Search</Button>
          </Form> */}
          </Navbar.Collapse>
        </div>
      </Navbar>
    );
  }
}

export default MyNav;
